<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">{{this.$route.name}}</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a @click="openPage('/corporate?page=' + currentPage)" class="btn-grey">
              <i class="fas fa-arrow-circle-left mr-5"></i>Back
            </a>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    v-model="formData.name"
                    name="name"
                    v-validate="'required'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Branch</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select name="branch" v-model="formData.branch_id">
                    <option :value="null">Please select</option>
                    <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{item.name}}</option>
                  </b-form-select>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Keysoft Customer ID</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    v-model="formData.keysoft_customer_id"
                    name="keysoft_customer_id"
                    v-validate="'required'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('keysoft_customer_id') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";

export default {
  name: "manageCorporate",
  data: function() {
    return {
      formData: {
        name: "",
        branch_id: null,
        keysoft_customer_id: "",
      },
      dataBranch: [],
      currentPage: 1
    };
  },
  methods: {
    async validateRegister() {
      let isValid = await this.$validator.validateAll()
      if (isValid) {
          axios.defaults.headers.common["X-Access-Token"] = Auth.Session.get().paradigm_token;
          try {
              if (this.$route.params.id) {
                await axios.put(`compro/v1/corporate/${this.$route.params.id}`, this.formData)
              } else {
                await axios.post(`compro/v1/corporate`, this.formData)
              }
              this.$router.push("/corporate");
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
          } catch (e) {
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
          }
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
    },
    openPage(event) {
      this.$router.push(event);
    },
    async fetchData() {
      axios.defaults.headers.common[
        "X-Access-Token"
      ] = Auth.Session.get().paradigm_token;
      let response = await axios.get(`compro/v1/corporate/${this.$route.params.id}`)
      this.formData = response.data.data
    },
    async getBranch() {
      let branch = await axios.get('fitness/v1/branch/')
      this.dataBranch = branch.data.data.rows
    }
  },
  created() {
    let urlParams = new URLSearchParams(window.location.search)
    let pageParams = urlParams.get('page')
    this.currentPage = (pageParams != null) ? parseInt(pageParams) : 1
    this.getBranch()
    if (this.$route.params.id) this.fetchData();
  }
};
</script>